// On-chain metriky zostavené pre úvodnú stránku Akadémie. Každá metrika obsahuje
// 5-stupňovú interpretačnú tabuľku (farebne kódovanú), aby stránka mohla vykresliť
// konzistentný panel "čo tento signál znamená?" bez dodatočnej logiky.

export const METRICAS_ONCHAIN = [
  {
    id: "fear-greed",
    nombre: "Fear & Greed Index",
    dificultad: "basica",
    descripcion: "Najpoužívanejší index na meranie všeobecného sentimentu krypto trhu. Kombinuje volatilitu, momentum, objem, sociálne siete, dominanciu a vyhľadávania Google na škále od 0 (Extrémny strach) po 100 (Extrémna chamtivosť). Warren Buffett: «Buď chamtivý, keď sa ostatní boja, a bojazlivý, keď sú ostatní chamtiví».",
    apiUrl: "https://api.alternative.me/fng/",
    interpretacion: [
      { rango: "0-25", senal: "Extrémny strach", color: "green",
        descripcion: "Trh v panike. Historicky signál na nákup pre dlhodobých holderov. Inštitucionálni investori tихо akumulujú." },
      { rango: "26-45", senal: "Strach", color: "lime",
        descripcion: "Negatívny sentiment. Retailoví investori odchádzajú. Príležitosť na analýzu bullish setupov." },
      { rango: "46-55", senal: "Neutrálne", color: "yellow",
        descripcion: "Trh v rovnováhe. Bez jasného biasu. Čakať na potvrdenie smeru." },
      { rango: "56-75", senal: "Chamtivosť", color: "orange",
        descripcion: "Mierna eufória. Trh rastie, ale opatrne. Zmenšiť pozície alebo začať vyberať čiastkové zisky." },
      { rango: "76-100", senal: "Extrémna chamtivosť", color: "red",
        descripcion: "Maximálna eufória. Historicky signál vrcholu trhu. Inštitucionálni investori distribuujú. Maximálna opatrnosť." },
    ],
  },
  {
    id: "nupl",
    nombre: "NUPL — Net Unrealized Profit/Loss",
    dificultad: "intermedia",
    descripcion: "Meria, či holderi Bitcoinu sú celkovo v nerealizovanom zisku alebo strate. Vypočíta sa ako (Market Cap − Realized Cap) / Market Cap. Je to jeden z najspoľahlivejších indikátorov na identifikáciu vrcholov a dien cyklu.",
    interpretacion: [
      { rango: "> 0.75", senal: "Eufória", color: "red",
        descripcion: "Veľká väčšina má veľké nerealizované zisky. Zóna inštitucionálnej distribúcie. Historicky predchádza korekciám 50-80%." },
      { rango: "0.5-0.75", senal: "Presvedčenie", color: "orange",
        descripcion: "Trh dozrieva v bullish cykle. Stále priestor na rast, ale s vyšším rizikom." },
      { rango: "0.25-0.5", senal: "Optimizmus", color: "lime",
        descripcion: "Zdravá bullish fáza. Dobrý vstupný bod pri korekciách." },
      { rango: "0-0.25", senal: "Nádej", color: "green",
        descripcion: "Prechod. Trh sa zotavuje zo dna. Príležitosť na akumuláciu." },
      { rango: "< 0", senal: "Kapitulácia", color: "green",
        descripcion: "Väčšina je v stratách. Maximálna panika. Historicky zóna dna cyklu. Najlepšia príležitosť na dlhodobý nákup." },
    ],
  },
  {
    id: "exchange-flow",
    nombre: "Exchange Inflow / Outflow",
    dificultad: "basica",
    descripcion: "Sleduje pohyb Bitcoinu na centralizované burzy a z nich. Keď holderi posielajú BTC na burzy, naznačuje to úmysel predať (bearish). Keď vyberajú BTC z búrz do súkromných peňaženiek, naznačuje to úmysel držať (bullish). Čisté toky na burzy zvyčajne predchádzajú poklesom.",
    interpretacion: [
      { rango: "Inflow alto", senal: "Medvedí", color: "red",
        descripcion: "Veľa BTC prichádza na burzy. Príprava na predaj. Zvyšuje sa tlak predajcov na krátku dobu." },
      { rango: "Outflow alto", senal: "Býčí", color: "green",
        descripcion: "Veľa BTC odchádza z búrz. Holderi ukladajú do vlastných peňaženiek. Znižuje sa dostupná ponuka na predaj." },
      { rango: "Flujo neutro", senal: "Bez signálu", color: "yellow",
        descripcion: "Čakať na potvrdenie ceny. Samo o sebe to nie je trigger." },
    ],
  },
  {
    id: "mvrv",
    nombre: "MVRV Ratio",
    dificultad: "intermedia",
    descripcion: "Market Value to Realized Value. Porovnáva aktuálnu trhovú cenu s priemernou cenou, za ktorú holderi kúpili svoj BTC (realizovaná cena). Vysoký MVRV znamená, že holderi mají veľké nerealizované zisky a môžu predávať. Nízky MVRV (blízko 1) historicky označuje dno cyklu.",
    interpretacion: [
      { rango: "MVRV > 3.5", senal: "Extrémne nadhodnotenie", color: "red",
        descripcion: "Holderi majú v priemere 3,5× svoju investíciu v zisku. Historicky zóna vrcholu. Iba 3-krát v histórii BTC." },
      { rango: "MVRV 2-3.5", senal: "Výstraha", color: "orange",
        descripcion: "Trh drahý, ale môže pokračovať. Postupne znižovať expozíciu." },
      { rango: "MVRV 1-2", senal: "Zdravý", color: "lime",
        descripcion: "Trh rozumne ohodnotený." },
      { rango: "MVRV < 1", senal: "Kapitulácia", color: "green",
        descripcion: "BTC obchoduje pod priemernou nákupnou cenou všetkých holderov. Historicky najlepšia príležitosť na dlhodobý nákup." },
    ],
  },
  {
    id: "dominancia-btc",
    nombre: "Dominancia Bitcoinu (BTC.D)",
    dificultad: "basica",
    descripcion: "Percento celkovej kapitalizácie krypta, ktoré predstavuje Bitcoin. Kľúčový indikátor na určenie, kedy rotovať medzi BTC a altcoinmi. Typický cyklus: BTC stúpa ako prvý (D stúpa) → ETH a large caps nasledujú → malé altcoiny explodujú (D klesá) → všetko kolabuje → BTC opäť vedie.",
    apiUrl: "https://api.coingecko.com/api/v3/global",
    interpretacion: [
      { rango: "D > 60% subiendo", senal: "BTC season", color: "orange",
        descripcion: "Kapitál prúdi do BTC. Konzervatívny trh. Čas mať viac BTC ako altcoinov." },
      { rango: "D 50-60%", senal: "Prechod", color: "yellow",
        descripcion: "BTC konsoliduje vedenie. Začať sledovať ETH a large caps." },
      { rango: "D 40-50% bajando", senal: "Altcoin season", color: "lime",
        descripcion: "Rotovať do kvalitných altcoinov. ETH, SOL, BNB vedú." },
      { rango: "D < 40%", senal: "Eufória altcoinov", color: "green",
        descripcion: "Plná altcoin season. Small caps sa násobujú. Maximálne riziko — ďalší pohyb je zvyčajne crash altcoinov." },
    ],
  },
  {
    id: "puell-multiple",
    nombre: "Puell Multiple",
    dificultad: "avanzada",
    descripcion: "Meria ziskovosť minerov Bitcoinu porovnaním dennej hodnoty vyťažených BTC s ročným priemerom. Mineri sú štrukturálni predajcovia BTC na úhradu prevádzkových nákladov. Vysoký Puell znamená, že mineri sú veľmi ziskoví a môžu viac predávať. Veľmi nízky Puell historicky označuje dno.",
    interpretacion: [
      { rango: "Puell > 4", senal: "Vrchol cyklu", color: "red",
        descripcion: "Mineri veľmi ziskoví. Vysoký predajný tlak minerov. Historicky zóna vrcholu (iba v extrémnych bull marketoch)." },
      { rango: "Puell 1-4", senal: "Aktívny trh", color: "orange",
        descripcion: "Produkcia a dopyt v rovnováhe." },
      { rango: "Puell 0.3-0.5", senal: "Kapitulácia minerov", color: "green",
        descripcion: "Mineri v ťažkostiach. Najslabší sa vzdávajú a cena zvyčajne označuje dno. Historicky príležitosť na nákup cyklu." },
    ],
  },
];

export const COLOR_DOT = {
  green: "bg-emerald-400",
  lime: "bg-lime-400",
  yellow: "bg-yellow-400",
  orange: "bg-orange-400",
  red: "bg-red-400",
};

export const DIFICULTAD_COLOR = {
  basica: "border-emerald-400/40 bg-emerald-400/[0.08] text-emerald-200",
  intermedia: "border-amber-400/40 bg-amber-400/[0.08] text-amber-200",
  avanzada: "border-red-400/40 bg-red-400/[0.08] text-red-200",
};

export const RECURSOS_EXTERNOS = [
  { nombre: "Glassnode", url: "https://glassnode.com",
    desc: "Profesionálny štandard on-chain metrík. Obmedzený bezplatný plán, premium pre inštitúcie." },
  { nombre: "CryptoQuant", url: "https://cryptoquant.com",
    desc: "Zameranie na toky búrz a indikátory minerov. Dobrý bezplatný plán." },
  { nombre: "LookIntoBitcoin", url: "https://www.lookintobitcoin.com",
    desc: "Historické indikátory cyklu BTC. 100% zadarmo a veľmi didaktické." },
];